import BlobProfile from './BlobProfile';
import { GridImagesCaption } from './GridImagesCaption';
import MessageBlobCaption from './MessageBlobCaption';
import MessageIllustration from './MessageIllustration';
import MessageIllustratedList from './MessageIllustratedList';
import MessageImageCaption from './MessageImageCaption';
import { QuoteComponent } from './QuoteComponent';
import MessageAnimation from './MessageAnimation';
import HighlightCaption from './HighlightCaption';

const messageBlobCaption = ({
  imageUrl,
  imageHeight,
  centreMessageOnMobile,
  colorThemeOption,
  captionImage,
  captionImageHeight,
  blobBleed,
  blobBleedConfig,
  shouldShowDecorativeBlob,
  imageWidth,
  blobHeight,
  showBorder,
  isCard,
  shouldUseConfigOffsetFirefox
}) => {
  return {
    component: MessageBlobCaption,
    imageUrl,
    imageHeight,
    centreMessageOnMobile,
    colorThemeOption,
    captionImage,
    captionImageHeight,
    blobBleed,
    blobBleedConfig,
    shouldShowDecorativeBlob,
    imageWidth,
    blobHeight,
    showBorder,
    isCard,
    shouldUseConfigOffsetFirefox
  };
};

const blobProfile = ({
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
}) => ({
  component: BlobProfile,
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
});

const imageMessage = ({
  imageKey,
  altText
}) => ({
  component: MessageImageCaption,
  imageKey,
  altText
});

const illustration = ({
  illustrationName,
  height,
  imageHeights,
  colorThemeOption
}) => Object.assign({
  component: MessageIllustration,
  illustrationName,
  height,
  imageHeights
}, colorThemeOption && {
  colorThemeOption
});

const illustratedList = ({
  illustrationName,
  height,
  imageHeights,
  colorThemeOption,
  animationDelay
}) => Object.assign({
  component: MessageIllustratedList,
  illustrationName,
  height,
  imageHeights
}, colorThemeOption && {
  colorThemeOption
}, {
  animationDelay
});

const animation = ({
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  isCard,
  blobHeight
}) => ({
  component: MessageAnimation,
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  blobHeight,
  isCard
});

const quote = ({
  imageUrl,
  imageHeights,
  altText
} = {}) => ({
  component: QuoteComponent,
  imageUrl,
  imageHeights,
  altText
});

const imagesInGrid = ({
  imageArray,
  bgColor
}) => ({
  component: GridImagesCaption,
  imageArray,
  bgColor
});

const highlightCaption = ({
  dataKey,
  highlightMessageKeys,
  landingPageComponent,
  illustrationName,
  height
}) => {
  return {
    component: HighlightCaption,
    landingPageComponent,
    dataKey,
    highlightMessageKeys,
    // Illustration passthrough props
    illustrationName,
    height
  };
};

export const MessageTypes = {
  imagesInGrid,
  quote,
  illustration,
  illustratedList,
  imageMessage,
  blobProfile,
  messageBlobCaption,
  animation,
  highlightCaption
};